import React, { useState } from 'react'
import NavigationLayout from '../../Components/NavigationLayout'
import { Page } from '@shopify/polaris'
import { Card, Button, Form, Alert } from 'react-bootstrap'
import axios from "../../Assets/Lib/axios";
import Cookies from "js-cookie";
import VouchersTable from './VouchersTable'
import {VERIFICATION_TYPES} from "../../global";

const UploadExcel = () => {
    const [file, setFile] = useState(null);
    const [error, setError] = useState('');
    const [isDragOver, setIsDragOver] = useState(false);
    const [failedVouchers, setFailedVouchers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0]
        setError('')

        if (selectedFile) {
            // Validate file type
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'application/vnd.ms-excel' // .xls
            ]

            if (!allowedTypes.includes(selectedFile.type)) {
                setError('Please select a valid Excel file (.xlsx or .xls)')
                setFile(null)
                return
            }

            const maxSize = 2 * 1024 * 1024 // 2MB in bytes
            if (selectedFile.size > maxSize) {
                setError('File size must be less than 2MB')
                setFile(null)
                return
            }

            setFile(selectedFile)
        }
    }

    const handleDragOver = (e) => {
        e.preventDefault()
        setIsDragOver(true)
    }

    const handleDragLeave = (e) => {
        e.preventDefault()
        setIsDragOver(false)
    }

    const handleDrop = (e) => {
        e.preventDefault()
        setIsDragOver(false)

        const droppedFile = e.dataTransfer.files[0]
        if (droppedFile) {
            const syntheticEvent = {
                target: {
                    files: [droppedFile]
                }
            }
            handleFileChange(syntheticEvent)
        }
    }

    const handleSubmit = () => {
        setIsLoading(true);
        if (file) {
            const accreditationTypeId = Cookies.get("accreditation_type_id");
            const formData = new FormData();
            formData.append("verification_code", file);
            formData.append("type_id", VERIFICATION_TYPES.APPLICATION_VERIFICATION_SUBMISSION);

            axios.post(`admin/v1/verification-code/import/${accreditationTypeId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then((res) => {
                if (res?.status === 200) {
                    const response = res?.data;
                    setFailedVouchers(response?.data?.failedVouchers || []);
                    // if (response?.data?.importedVouchers?.length > 0) {
                    //     // show success message on ui
                    //     setIsSubmitted(true);
                    // }
                    setIsSubmitted(true);
                    // Set file to null
                    setFile(null);
                    // Reset error message
                    setError('');
                }
            })
                .catch((err) => {
                    console.error("Submission error:", err);
                    setError('An error occurred while uploading the file. Please try again.');
                    setFailedVouchers([]);
                    setIsSubmitted(false);
                    // Reset file state
                    setFile(null);
                })
                .finally(() => setIsLoading(false));
        } else {
            alert("Please select a file before submitting.");
        }
    }

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes'
        const k = 1024
        const sizes = ['Bytes', 'KB', 'MB', 'GB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }

    return (
        <NavigationLayout>
            <Page fullWidth title="Upload Verification Code"
                breadcrumbs={[{ url: "/admin/upload-verification-code" }]}>
                {/* Upload Excel Card */}
                <Card className='excel-card'>
                    <Card.Body>
                        <h3 className="text-center mb-4">Upload Verification Code</h3>
                        <Form>
                            <Form.Group controlId="formFile" className="mb-4">
                                <Form.Label>Choose an Excel file (.xlsx, .xls)</Form.Label>

                                <div className="custom-file-input">
                                    <input
                                        type="file"
                                        accept=".xlsx,.xls"
                                        onChange={handleFileChange}
                                        id="fileInput"
                                    />
                                    <div
                                        className={`file-input-display ${isDragOver ? 'drag-over' : ''}`}
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                        onClick={() => document.getElementById('fileInput').click()}
                                    >
                                        <span className="file-input-icon">📊</span>
                                        <div className="file-input-text">
                                            {file ? 'Click to change file' : 'Click to browse or drag & drop'}
                                        </div>
                                        <div className="file-input-subtext">
                                            Supports .xlsx and .xls files (Max 2MB)
                                        </div>
                                    </div>
                                </div>
                            </Form.Group>

                            {error && (
                                <Alert variant="danger" className="mb-4">
                                    {error}
                                </Alert>
                            )}

                            {file && (
                                <div className="file-info mb-4">
                                    <div>
                                        <strong>File selected:</strong>
                                        <div className="file-name">{file.name}</div>
                                        <div className="file-details mt-2">
                                            <small className="text-muted">
                                                Size: {formatFileSize(file.size)} |
                                                Type: {file.type || 'Excel File'} |
                                                Last Modified: {new Date(file.lastModified).toLocaleDateString()}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {isSubmitted && (
                                <Alert variant="success" className="mb-4">
                                    File uploaded successfully! {failedVouchers.length > 0 ? 'Some vouchers failed to process.' : 'All vouchers processed successfully.'}
                                </Alert>)}

                            <div className="d-flex justify-content-center">
                                <Button
                                    variant="primary"
                                    onClick={handleSubmit}
                                    disabled={!file || isLoading}
                                    className="submit-btn"
                                >
                                    {isLoading ? "Uploading..." : (file ? 'Submit File' : 'Select a File First')}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>

                {/* Failed Voucher Table */}
                <VouchersTable vouchers={failedVouchers} tabelTitle="Failed Vouchers" />

            </Page>
        </NavigationLayout>
    )
}

export default UploadExcel